/**
 * Class description
 *
 * Created: 2017-11-17
 * @author jonas
 */

import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/SpineAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";

// To extend enum
// declare module "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName" {
//     export enum ResourcesGroupName {
//         GAME_GROUP = "gamegroup"
//     }
// }

// const temp = ResourcesGroupName as any;
// temp["GAME_GROUP"] = "gamegroup";

export class DeadwoodGameAssets {

    public static getSymbolStateTexturePath(symbolName:string, stateName:string | null = null):string {
        if(symbolName === "S" && (stateName === "landing" || stateName === "win")) {
            return "scatterLanding";
        }
        if(symbolName === "B" && stateName === "landing") {
            return "empty";
        }
        if(stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "_" + stateName;
    }

    public static getSymbolStateTextures(symbolName:string, stateName:string | null = null):PIXI.Texture[] {
        return GameResources.getTextures(DeadwoodGameAssets.getSymbolStateTexturePath(symbolName, stateName));
    }

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [
            {
                name : "fonts",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new BitmapFontAsset("numbersOpenSans800", "fonts/bitmapfonts/NumbersOpenSans800.fnt")
                ]
            }
        ],

        main : [
            {
                name : "fonts",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new BitmapFontAsset("FreespinNumber", "fonts/bitmapfonts/FreespinNumber.fnt"),
                    new BitmapFontAsset("TotalMultipliers", "fonts/bitmapfonts/TotalMultipliers.fnt"),
                    new BitmapFontAsset("DeadwoodCountUpFont", "fonts/bitmapfonts/DeadwoodCountUpFont.fnt"),
                    new BitmapFontAsset("NumbersWaysWon", "fonts/bitmapfonts/NumbersWaysWon.fnt")
                ]
            },
            {
                name : "main",
                assets : [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json")
                ],
                animations : {
                    "reelBackground" : "Reel",
                    "logo" : "Logo",
                    "windowHole" : "shoot/WindowHole",
                    "gunHoles1" : "initialWin/gunHoles_a",
                    "gunHoles2" : "initialWin/gunHoles_b",
                    "scatterFireBg" : "Scatter/scGlow_Nor",
                    "multiplierPosterNormal" : "multiplier/PaperClean",
                    "multiplierLandingNormal" : "multiplier/linerLandingNormal/linerLanding_",
                    "multiplierDragNormal" : "multiplier/linerDragNormal/linerDrag_",
                    "multiplierPosterFS" : "multiplier/DirtyPaper",
                    "multiplierLandingFS" : "multiplier/linerLandingDirty/linerLandingDr_",
                    "multiplierDragFS" : "multiplier/linerDragDirty/linerDragDr_",
                    "multiplierDragDagger" : "multiplier/linerDragDagger/daggerDrag_",
                    "multiplierDaggerEnd" : "multiplier/dagger/Dagger",
                    "multiplierFire" : "multiplier/multiplierFire/multiFire_",
                    "bonusIntroPanel" : "bonusintro/ShootOut",
                    "shootOutText" : "bonusintro/shootOut_t",
                    "fsRetrigger" : "freespin/plus1_FS",
                    "bigWinGoldCoin" : "bigWin/particles/coinGold/coinGold_",
                    "bigWinSilverCoin" : "bigWin/particles/coinSilver/coinSilver_",
                    "bigWinGoldPan" : "bigWin/goldPan",
                    "bigWinGoldPile" : "bigWin/goldPile",
                    "bigWinFrontCoins0" : "bigWin/frontcoins/coinLevel1",
                    "bigWinFrontCoins1" : "bigWin/frontcoins/coinLevel2",
                    "bigWinFrontCoins2" : "bigWin/frontcoins/coinLevel3",
                    "bigWinBrokenGlass" : "bigWin/bigHoleb",
                    "GUNSLINGERButton" : "fsintro/GunslingerFeature",
                    "HUNTERButton" : "fsintro/HunterFeature",
                    "volatilityBar" : "fsintro/volatilityBar",
                    "fsOutroFeature1" : "fsoutro/GunslingerFeatureOutro",
                    "fsOutroFeature2" : "fsoutro/HunterFeatureoutro",
                    "fsOutroNoWin" : "fsoutro/NoReward"
                }
            },
            {
                name : "mainDark",
                assets : [
                    new TextureAsset("mainDark0", "sheets/main/mainDark0.json"),
                    new TextureAsset("mainDark1", "sheets/main/mainDark1.json")
                ],
                animations : {
                    // "reelFrame" : "DWFrame",
                    // "waysWonText" : "winways/WaysWonText",
                    // "wayWonText" : "winways/WayWonText",
                }
            },
            {
                name : "mainHigh",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("mainHigh0", "sheets/main/mainHigh0.json")
                ],
                animations : {
                    "reelFrame" : "DWFrame",
                    "waysWonText" : "winways/WaysWonText",
                    "wayWonText" : "winways/WayWonText",
                }
            },
            {
                name : "mainJpeg",
                assets : [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json")
                ],
                animations : {
                    "WInitial" : "individual_intialwin/intialW",
                    "WIndividual" : "individual_intialwin/individualW",
                    "nearWinFireBg" : "nearWin/nearGlow_Jpg",
                    "hotReelFrame" : "reelHot",
                    "fsFireBg" : "nearWin/nearFire_bg",
                    "bonusReelFrame" : "bonus/rectFrame",
                    "bonusAttention" : "bonus/bountyBonus/bBonus_",
                    "redWildPt" : "bonus/redWild_particle/redW_",
                    "fireParticle1" : "particles/ptA_b",
                    "fireParticle2" : "particles/ptA_a",
                    "fireParticle3" : "particles/ptA_c",
                    "bigWinSandFallBottom" : "bigWin/goldSend_bottom",
                    "bigWinSandFallTop" : "bigWin/goldSend_top",
                    "bigWinPigBg" : "bigWin/pigBG",
                    "W_glow" : "W/W_glow_x",
                    "bigWinPt" : "bigWin/particles/bgPt",
                    "chosenGlow" : "fsintro/ChosenBannerGlow6FPS/ChosenBannerGlow_",
                    "outroGlow" : "fsoutro/outroGlow",
                    "bgLight" : "bigWin/pileLight",
                    "waysHighlight" : "idle/576w/576w_",
                    "xNudgeHighlight" : "idle/xNudge/xLight_",
                    "horseLeftHighlight" : "idle/horseL/horseL_",
                    "horseRightHighlight" : "idle/horseR/horseR_"
                }
            },
            {
                name : "mainJpegHigh",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("mainJpegHigh0", "sheets/mainJpeg/mainJpegHigh0.json")
                ],
                animations : {
                    "GUNSLINGERGlow" : "fsintro/gunslingerGlow",
                    "HUNTERGlow" : "fsintro/hunterGlow",
                    "fsintroParticle" : "fsintro/introPT"
                }
            },
            {
                name : "symbols",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json"),
                    new TextureAsset("symbols1", "sheets/symbols/symbols1.json")
                ],
                animations : {
                    "wildMulti" : "W/W_x",
                    "wildMulti_spin" : "W/W_spin_x",
                    "scatterLanding" : "S/landing/scatterAttention_symAnimation_",
                    "bustedWild" : "bustedwild/radWild",
                    "bustedWildFrame" : "bustedwild/wildFrame"
                }
            },
            {
                name : "spine",
                assets : [
                    new SpineAsset("initialWin_symGlow", "spine/initial/initialWin_symGlow.json"),
                    new SpineAsset("InitialWinPt", "spine/initial/initialWin_particleVFX.json"),
                    new SpineAsset("individualWin_symGlow", "spine/individual/individualWin_symGlow.json"),
                    new SpineAsset("nearWin_burningTrack", "spine/nearWin/nearWin_burningTrack.json"),
                    new SpineAsset("nearWin_explosion", "spine/nearWin/nearExpl.json"),
                    new SpineAsset("scatter_Tail", "spine/scatter/scatter_symTail.json"),
                    new SpineAsset("scatterAttention_fireToggle", "spine/scatter/scatterAttention_fireToggle.json"),
                    new SpineAsset("B_rotate_add", "spine/bonus/rotatingB_add.json"),
                    new SpineAsset("B_rotate", "spine/bonus/rotatingB_normal.json"),
                    new SpineAsset("nearWin_shootOut", "spine/nearWin/nearWin_shootOut.json"),
                    new SpineAsset("shootOut_hotWave", "spine/bonus/glow_underReel.json"),
                    new SpineAsset("L1_wildOverlay", "spine/bonus/wild_inshL1.json"),
                    new SpineAsset("L2_wildOverlay", "spine/bonus/wild_inshL2.json"),
                    new SpineAsset("L3_wildOverlay", "spine/bonus/wild_inshL3.json"),
                    new SpineAsset("L4_wildOverlay", "spine/bonus/wild_inshL4.json"),
                    new SpineAsset("L5_wildOverlay", "spine/bonus/wild_inshL5.json"),
                    new SpineAsset("bonusWildShow", "spine/bonus/wildComing.json"),
                    new SpineAsset("bonusWildGlow", "spine/bonus/bonusWildPtGlow.json"),
                    new SpineAsset("shootOutPanel", "spine/shootoutintro/shootOut_panelPath.json"),
                    new SpineAsset("shootOut_glowAdd", "spine/shootoutintro/introGlow_ADD.json"),
                    new SpineAsset("shootOut_name", "spine/shootoutintro/SHOOTOUT_Normal.json"),
                    new SpineAsset("shootOut_sparkAdd", "spine/shootoutintro/introSpark_ADD.json"),
                    new SpineAsset("bigWin_pileAdd", "spine/bigwin/bigWin_pileADD.json"),
                    new SpineAsset("bigWin_shoot0", "spine/bigwin/shootAnimation/bigWin_rideHoles.json"),
                    new SpineAsset("bigWin_shoot1", "spine/bigwin/shootAnimation/bigWin_loadHoles.json"),
                    new SpineAsset("bigWin_shoot2", "spine/bigwin/shootAnimation/bigWin_deadHoles.json"),
                    new SpineAsset("bigWin_shoot3", "spine/bigwin/shootAnimation/bigWin_pigsHoles.json"),
                    new SpineAsset("bigWin_shootAdd0", "spine/bigwin/shootAnimation/bigWin_rideADD.json"),
                    new SpineAsset("bigWin_shootAdd1", "spine/bigwin/shootAnimation/bigWin_loadADD.json"),
                    new SpineAsset("bigWin_shootAdd2", "spine/bigwin/shootAnimation/bigWin_deadADD.json"),
                    new SpineAsset("bigWin_shootAdd3", "spine/bigwin/shootAnimation/bigWin_pigsADD.json"),
                    new SpineAsset("bigWin_text0", "spine/bigwin/textAnimation/bigWin_loadText.json"),
                    new SpineAsset("bigWin_text1", "spine/bigwin/textAnimation/bigWin_rideText.json"),
                    new SpineAsset("bigWin_text2", "spine/bigwin/textAnimation/bigWin_deadText.json"),
                    new SpineAsset("bigWin_text3", "spine/bigwin/textAnimation/bigWin_pigsText.json"),
                    new SpineAsset("bigWin_pigs", "spine/bigwin/bigWin_pigsAnim.json"),
                    new SpineAsset("nudgePt", "spine/nudge/nudgePt_ADD.json"),
                    new SpineAsset("multiplierDagger", "spine/multiplier/dagger_Normal.json"),
                    new SpineAsset("tumbleWeed", "spine/idle/tumbleWeed_Normal.json"),
                    new SpineAsset("dust", "spine/idle/dust_Normal.json"),
                    new SpineAsset("backgroundIdle", "spine/idle/bGround_Normal.json"),
                    new SpineAsset("metalPanel", "spine/idle/metalPanel_Normal.json")
                ]
            },
        ]
    };
}
